<template>
    <div class="perfect-scrollbar-off">
        <vue-progress-bar></vue-progress-bar>

        <div class="wrapper ">
            <side-nav :menu-links="menuItems"></side-nav>
            <div class="main-panel">
                <top-nav></top-nav>
                <div class="content">
                    <slot></slot>
                    <NewAutoInvestmentPresetModal :user="this.user" v-on:presetModalClose="closePresetModal()" ref="auto_investment_preset_modal_ref"/>
                    <InvestorAgreementUpdateModal :user="this.user" v-on:updateModalClose="closeUpdateModal()" ref="investor_agreement_update_ref"/>
                    <NewInvestorEmploymentModal style="z-index: 1500" :user="this.user" ref="new_investor_employment_modal_ref"/>
                </div>
                <footer></footer>
            </div>
        </div>
        <v-tour name="guideDesktop" :steps="stepsDesktop">
            <template slot-scope="tour">
                <transition name="fade">
                <v-step style="border-radius: 6px;"
                    v-if="tour.steps[tour.currentStep]"
                    :key="tour.currentStep"
                    :step="tour.steps[tour.currentStep]"
                    :previous-step="tour.previousStep"
                    :next-step="tour.nextStep"
                    :stop="tour.stop"
                    :skip="tour.skip"
                    :is-first="tour.isFirst"
                    :is-last="tour.isLast"
                    :labels="tour.labels"

                >
                    <template v-if="tour.currentStep === 0">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>1/4</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="tour.skip" class="v-step__button v-step__button-skip" style="border-radius: 6px;">Skip</button>
                            <button @click="tour.nextStep" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 1">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>2/4</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="tour.previousStep" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="tour.nextStep" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 2">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>3/4</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="tour.previousStep" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="tour.nextStep" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 3">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>4/4</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="tour.previousStep" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="tour.stop" class="v-step__button v-step__button-stop" style="border-radius: 6px;">Done</button>
                        </div>
                    </template>
                </v-step>
                </transition>
            </template>
        </v-tour>
        <v-tour name="guideMobile" :steps="stepsMobile">
            <template slot-scope="tour">
                <transition name="fade">
                <v-step style="border-radius: 6px;"
                    v-if="tour.steps[tour.currentStep]"
                    :key="tour.currentStep"
                    :step="tour.steps[tour.currentStep]"
                    :previous-step="tour.previousStep"
                    :next-step="tour.nextStep"
                    :stop="tour.stop"
                    :skip="tour.skip"
                    :is-first="tour.isFirst"
                    :is-last="tour.isLast"
                    :labels="tour.labels"

                >
                    <template v-if="tour.currentStep === 0">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>1/6</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="tour.skip" class="v-step__button v-step__button-skip" style="border-radius: 6px;">Skip</button>
                            <button @click="mobileNextStep(tour)" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 1">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>2/6</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="mobilePreviousStep(tour)" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="mobileNextStep(tour)" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 2">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>3/6</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="mobilePreviousStep(tour)" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="mobileNextStep(tour)" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 3">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>4/6</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="mobilePreviousStep(tour)" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="mobileNextStep(tour)" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 4">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>5/6</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="mobilePreviousStep(tour)" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="mobileNextStep(tour)" class="v-step__button v-step__button-next" style="border-radius: 6px;">&gt;</button>
                        </div>
                    </template>
                    <template v-if="tour.currentStep === 5">
                        <div slot="header">
                            <div class="row mb-3">
                            <div class="col-12 d-flex flex-row justify-content-end" style="color:#a5adbe;"><small>6/6</small></div>
                            </div>
                        </div>
                        <div slot="actions">
                            <button @click="mobilePreviousStep(tour)" class="v-step__button v-step__button-previous" style="border-radius: 6px;">&lt;</button>
                            <button @click="tour.stop" class="v-step__button v-step__button-stop" style="border-radius: 6px;">Done</button>
                        </div>
                    </template>
                </v-step>
                </transition>
            </template>
        </v-tour>
    </div>
</template>

<script>
  import { api, siteName } from './../../config'
  import jwtToken from '../../helpers/jwt-token';
  import SideNav from "../navs/SideNav";
  import TopNav from "../navs/TopNav";
  import Footer from "../navs/Footer";
  import NewAutoInvestmentPresetModal from "../../components/modals/NewAutoInvestmentPresetModal";
  import InvestorAgreementUpdateModal from "../../components/modals/InvestorAgreementUpdateModal";
  import NewInvestorEmploymentModal from "../../components/modals/NewInvestorEmploymentModal";

  export default {
      name: 'Default',
      components: {Footer, TopNav, SideNav, NewAutoInvestmentPresetModal, InvestorAgreementUpdateModal, NewInvestorEmploymentModal},
      data () {
          return {
                user: null,
                menuItems: [],
                checkIfHasBots: true,
                checkIfHideAutoInvest: false,
                checkIfUserApproved: false,
                checkIfAgreesUpdate: false,
                checkIfEmploymentUpdated: false,
                stepsDesktop: [
                    {
                        target: "#cashbalance-guide",
                        content: 'View your cash balance here',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#topup-guide',
                        content: 'Click here to top-up your account',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#withdraw-guide',
                        content: 'Click here to withdraw money from your account',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: "#notes-guide",
                        content: 'Click here to explore our Investment Notes',
                        params: {
                            enableScrolling: false,
                            placement: 'left',
                            modifiers: {
                                preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'window',
                                }
                            }
                        }
                    },
                ],
                stepsMobile: [
                    {
                        target: '#settingMenuToggler',
                        content: 'Press here to view your cash balance or make a transfer',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: "#cashbalance-guide",
                        content: 'View your cash balance here',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#topup-guide',
                        content: 'Press here to top-up your account',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: '#withdraw-guide',
                        content: 'Press here to withdraw money from your account',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: "#sideMenuToggler",
                        content: 'Press here to open the navigation panel',
                        params: {
                            enableScrolling: false
                        }
                    },
                    {
                        target: "#notes-guide",
                        content: 'Press here to explore our Investment Notes',
                        params: {
                            enableScrolling: false,
                            placement: 'top',
                            modifiers: {
                                preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'window',
                                }
                            }
                        },
                    },
                ],
          }
      },

      created () {
          if (this.$store.state.auth) {
              this.user = this.$store.state.auth;
              this.checkIfAgreesUpdate = this.user.check_if_agrees_agreement_update
              this.checkIfHasBots = this.user.check_if_has_auto_invest_bots
              this.checkIfHideAutoInvest = this.user.check_if_hide_auto_invest_message
              this.checkIfUserApproved = this.$store.getters.isApplicationApproved
              this.checkIfEmploymentUpdated = this.user.check_if_employment_updated
          }
      },

      mounted () {
            this.menuItems = [
                {
                    id: 1,
                    text: '<i class="tim-icons icon-chart-pie-36"></i>&nbsp;&nbsp;Dashboard',
                    link: 'dashboard',
                    visible: true,
                },
                {
                    id: 2,
                    text: '<i class="tim-icons icon-paper"></i>&nbsp;&nbsp;My Notes',
                    link: 'notes',
                    visible: (this.user.role === 'investor'),
                },
                {
                    id: 2,
                    text: '<i class="tim-icons icon-paper"></i>&nbsp;&nbsp;My Notes',
                    link: 'bo_notes',
                    visible: (this.user.role === 'businessowner'),
                },
                {
                    id: 3,
                    text: '<i class="tim-icons icon-user-run"></i>&nbsp;&nbsp;My Activity',
                    link: 'my_activity',
                    visible: true,
                },
                {
                    id: 4,
                    text: '<i class="tim-icons icon-laptop"></i>&nbsp;&nbsp;Auto Investment',
                    link: 'auto_investment',
                    visible: (this.user.role === 'investor' && this.user.is_inv_fund_managed == 0),
                },
                {
                  id: 5,
                  text: '<i class="tim-icons icon-single-02"></i>&nbsp;&nbsp;My Referrals',
                  link: 'referral',
                  visible: true,
                  // only applicable for investors at the moment.
                  // visible: (this.user.role === 'investor')
                },
                {
                    id: 6,
                    text: '<i class="tim-icons icon-bell-55"></i>&nbsp;&nbsp;My Notifications',
                    link: 'notifications',
                    visible: true,
                }
            ];

            // Approved investor, agrees to latest tnc, employment updated, and no auto investments
            if (this.user.role == 'investor' && !this.checkIfHasBots && !this.checkIfHideAutoInvest && this.checkIfUserApproved && this.checkIfAgreesUpdate && this.checkIfEmploymentUpdated && this.user.is_inv_fund_managed == 0) {
                // Only show this preset when on Dashboard
                if (this.$route.name == 'dashboard')
                {
                    this.openPresetModal()
                }
            }

            // Investor, not yet agrees to latest tnc
            if (this.user.role == 'investor' && !this.checkIfAgreesUpdate) {
                this.openUpdateModal()
            }

            // Approved investor, agrees to latest tnc, employment not updated
            if (this.user.role == 'investor' && this.checkIfUserApproved && this.checkIfAgreesUpdate && !this.checkIfEmploymentUpdated)
            {
                this.openEmploymentModal()
            }
      },

      methods: {
        openEmploymentModal() {
            this.$modal.show('new_investor_employment_modal');
        },

        openUpdateModal() {
            $('#investor_agreement_update').modal({backdrop: 'static', keyboard: false})
            $("#investor_agreement_update").modal('show')
        },
        closeUpdateModal() {
            $("#investor_agreement_update").modal('hide')
        },
        openPresetModal() {
            // $("#auto_investment_preset_modal").modal('show')
            this.$modal.show('new_auto_investment_preset_modal');
        },
        closePresetModal() {
            // $("#auto_investment_preset_modal").modal('hide')
            this.$modal.hide('new_auto_investment_preset_modal');
        },
        mobilePreviousStep(tour) {
            if (tour.currentStep === 5) {
                this.$nextTick(() => {
                    if ($('[id="sideMenuToggler"]')[0].parentElement.getAttribute('class').includes('toggled') == true) {
                        $('[id="sideMenuToggler"]').click()
                        setTimeout ( () => tour.previousStep(), 400);
                    } else {
                        tour.previousStep()
                    }
                })
            } else if (tour.currentStep === 4 || tour.currentStep === 3 || tour.currentStep === 2) {
                this.$nextTick(() => {
                    if (!$('[id="settingMenuToggler"]')[0].getAttribute('aria-expanded') ||
                        $('[id="settingMenuToggler"]')[0].getAttribute('aria-expanded') == 'false') {
                        $('[id="settingMenuToggler"]').click()
                        setTimeout ( () => tour.previousStep(), 400);
                    } else {
                        tour.previousStep()
                    }
                })
            } else if (tour.currentStep === 1) {
                this.$nextTick(() => {
                    if ($('[id="settingMenuToggler"]')[0].getAttribute('aria-expanded') == 'true') {
                        $('[id="settingMenuToggler"]').click()
                        setTimeout ( () => tour.previousStep(), 400);
                    } else {
                        tour.previousStep()
                    }
                })
            } else {
                tour.previousStep()
            }
        },
        mobileNextStep(tour) {
            if (tour.currentStep === 0 || tour.currentStep === 1 || tour.currentStep === 2) {
                this.$nextTick(() => {
                    if (!$('[id="settingMenuToggler"]')[0].getAttribute('aria-expanded') ||
                        $('[id="settingMenuToggler"]')[0].getAttribute('aria-expanded') == 'false') {
                        $('[id="settingMenuToggler"]').click()
                        setTimeout ( () => tour.nextStep(), 400);
                    } else {
                        tour.nextStep()
                    }
                })
            } else if (tour.currentStep === 3) {
                this.$nextTick(() => {
                    if ($('[id="settingMenuToggler"]')[0].getAttribute('aria-expanded') == 'true') {
                        $('[id="settingMenuToggler"]').click()
                        setTimeout ( () => tour.nextStep(), 400);
                    } else {
                        tour.nextStep()
                    }
                })
            } else if (tour.currentStep === 4) {
                this.$nextTick(() => {
                    if ($('[id="sideMenuToggler"]')[0].parentElement.getAttribute('class').includes('toggled') == false) {
                        $('[id="sideMenuToggler"]').click()
                        setTimeout ( () => tour.nextStep(), 400);
                    } else {
                        tour.nextStep()
                    }
                })
            } else {
                tour.nextStep()
            }
        }
      }
  }
</script>

<style scoped lang="scss">
</style>
